<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onCarparkFilterChange" />

      <AppFilter 
        v-show="false"
        ref="typeFilter" 
        v-on:filter-data-change="onTypeFilterDataChange" />

      <AppFilter 
        v-show="false"
        ref="customerFilter" 
        filterKey="customerID"
        v-on:filter-data-change="onCustomerFilterDataChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onLicenseFilterDataChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'carparkID',
    text: 'CP ID',
  },
  {
    key: 'carparkCode',
    text: 'CP Code',
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem.carparkID && !dataItem._carparkName) {
        return '';
      }
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: 'carparkCode1',
    text: 'ParkAide Car Park ID',
  },
  // {
  //   key: 'parkingLicense',
  //   text: 'Parking License',
  //   table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
  //     let parameterItem = dataParameter[parameterIndex];
  //     let dataItem = dataResult[dataIndex];
  //     if(!dataItem.licenseID || !dataItem._licenseNum || !dataItem._carparkNum) {
  //       return '';
  //     }
  //     if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
  //       return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
  //     }
  //     return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
  //   },
  //   form_hide: true, 
  // },
  // {
  //   key: 'commencementDate',
  //   text: 'Commencement Date',
  //   table_custom: helper.tableCustomDate,
  // },
  // {
  //   key: 'status',
  //   text: 'Subscription Status',
  // },
  // {
  //   key: '_passcardStatus',
  //   text: 'Passcard Status',
  // },
  // {
  //   key: '_parkerName',
  //   text: 'Parker Full Name',
  // },
  {
    key: '_parkerMobile',
    text: 'Mobile No',
  },
  // {
  //   key: '_parkaideActive',
  //   text: 'ParkAide Active',
  //   table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
  //     let parameterItem = dataParameter[parameterIndex];
  //     let dataItem = dataResult[dataIndex];
  //     let syncSeason = dataItem['_syncSeason'];
  //     if(!syncSeason) {
  //       return 'NA'
  //     }
  //     return syncSeason['active'] ? 'Active' : 'Block';
  //   },
  // },
  {
    key: '_syncButton',
    text: 'Sent Date',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      // let syncSeason = dataItem['_syncSeason'];
      // if(!syncSeason || !syncSeason['sentDate']) {
      //   return 'NA'
      // }
      return helper.formatDateTime(dataItem['sentDate']);
    },
  }
];
const PARAM_MAP = helper.transformParamToMap(PARAM);


const PASSCARD_PARAM = [
  {
    key: '_carparkName',
    text: 'Car Park',
    form_input_attr: { disabled: true },
  },
  {
    key: 'passcard',
    text: 'Passcard Number',
    form_select: {
      data: [],
      formatSelectOptionText: k => k.option,
    },
  },
];
const PASSCARD_PARAM_MAP = helper.transformParamToMap(PASSCARD_PARAM);

export default {
  name: "PageManualParkaide",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'ParkAide Subscription' },
      ],

      PARAM,
      PARAM_MAP,

      PASSCARD_PARAM,
      PASSCARD_PARAM_MAP,

      isInitialSetCustomer: true,

      pagePasstype: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageLease: null,
      pageSeason: null,
      pageSeasonFees: {},
      pageParker: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['customerFilter'].formatFilterOptionText = (dataItem) => dataItem.nationalID ? `${dataItem.name} (${dataItem.nationalID})` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = (dataItem) => {
      let text = helper.plFormPLNum(dataItem.licenseOperatorNum, dataItem.carparkID);

      let customer = dataItem['_customer'];
      if(customer) {
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      } else {
        text = 'All Customers';
      }
      return text;
    };
    this.loadPasscardType();
  },
  methods: {
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCustomerFilter() {
      // TODO skip type filter
      // let filterData = this.pageCustomer.filter(k => this.$refs['typeFilter'].filterValue === 'Company' ? k.isCompany : !k.isCompany);
      // filterData = filterData.filter(k => this.pageLicense.find(j => helper.compareID(j.customerID, k['id'])));
      // this.$refs['customerFilter'].setFilterDataWithValueIfFirstLoad(filterData, this.$route.query.customerID);
    },
    setLicenseFilter() {
      // TODO skip type filter
      // let filterData = this.pageLicense.filter(k => {
      //   if(!k['_customer']) return;
      //   if(this.$refs['typeFilter'].filterValue === 'Company') {
      //     return k['_customer'].isCompany
      //   } else {
      //     return !k['_customer'].isCompany
      //   }
      // });
      // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Customer'}, filterData), this.$route.query.licenseID);
      // // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(filterData, this.$route.query.licenseID);
    },
    loadLicense() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;

          if(response.data && response.data.length > 0) {
            response.data.forEach(k => {
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
              k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            });

            // TODO skip type filter
            // if(helper.checkRoleIsParker()) {
            //   // if(helper.checkRoleIsCompany()) {
            //   //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}]);
            //   // } else {
            //   //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Personal', name:'Personal'}]);
            //   // }
            //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}, {id:'Personal', name:'Personal'}]);
            // } else {
            //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}, {id:'Personal', name:'Personal'}]);
            // }
            
            // let setCustomerFilter = false;
            // if(this.isInitialSetCustomer) {
            //   this.isInitialSetCustomer = false;
            //   let customerID = this.$route.query.customerID;
            //   if(customerID) {
            //     let customer = this.pageCustomer.find(k => helper.compareID(k.id, customerID));
            //     if(customer) {
            //       this.$refs['typeFilter'].setFilterValue(customer.isCompany ? 'Company' : 'Personal');
            //       this.setCustomerFilter();
            //       setCustomerFilter = true;
            //     }
            //   }
            // }

            // if(!setCustomerFilter) {
            //   this.setCustomerFilter();
            // }

            // let setLicenseFilter = false;
            // if(this.isInitialSetCustomer) {
            //   this.isInitialSetCustomer = false;
            //   let licenseID = this.$route.query.licenseID;
            //   if(licenseID) {
            //     let customerID = (this.pageLicense.find(k => helper.compareID(k.id, licenseID)) || {})['customerID'];
            //     let customer = (this.pageCustomer.find(k => helper.compareID(k.id, customerID)) || {});
            //     if(customer) {
            //       this.$refs['typeFilter'].setFilterValue(customer.isCompany ? 'Company' : 'Personal');
            //       this.setLicenseFilter();
            //       setLicenseFilter = true;
            //     }
            //   }
            // }

            // if(!setLicenseFilter) {
            //   this.setLicenseFilter();
            // }

            this.loadPasscard();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No license data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/passcard/';

      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadSyncSeason();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSyncSeason() {
      let url = helper.SERVER_URL + '/api2';
      url += '/sync/season/?1=1';
      if(this.$refs['licenseFilter'].filterValue) {
        // url += '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      } else if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      url += '&sort=createDate'
      // TODO skip type filter
      // if(this.$refs['typeFilter'].filterValue === 'Personal') {
      //   url += '&isCompany=0';
      // } else {
      //   url += '&isCompany=1';
      // }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      let feedbackItem = 'season status data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          this.seasonSyncStatus = response.data.sort((a,b) => b.createDate - a.createDate);
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLease() {
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['licenseFilter'].filterValue) {
        // url += '/license/' + this.$refs['licenseFilter'].filterValue;
      } else if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/lease/';
      // TODO skip type filter
      // if(this.$refs['typeFilter'].filterValue === 'Personal') {
      //   url += '?isCompany=0';
      // } else {
      //   url += '?isCompany=1';
      // }
      // // url += '&isParkAide=1'
      // // url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage('');
            response.data = response.data.filter(k => k['isParkAide']);
            // TODO skip type filter
            // response.data = response.data.filter(k => {
            //   let temp = this.pageCustomer.find(j => helper.compareID(j.id, k['customerID'])) || {};
            //   return this.$refs['typeFilter'].filterValue === 'Company' ? temp['isCompany'] : !temp['isCompany'];
            // });
            this.pageLease = response.data;
            this.pageLease.forEach(k => {
              k['_syncSeason'] = this.seasonSyncStatus.find(j => j.leaseID === k.id);

              if(k['isParkAide']) {
                k['_passcardStatus'] = 'ParkAide Blocked';

                if(k['status'] === 'Active' || k['status'] === 'Pending Termination') {
                  if(new moment() > helper.parseDateTime(k['commencementDate'])) {
                        k['_passcardStatus'] = 'ParkAide Active';
                  }
                }
              } else {
                if(k['passcardID']) {
                  k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID']));
                  k['_passcardStatus'] = 'Passcard Issued';
                } else {
                  if(k['status'] === 'Active' || k['status'] === 'Stop Bill') {
                    if(k['reason'].includes('Pending')) {
                      k['_passcardStatus'] = 'Pending Passcard Issuence';
                    } else {
                      k['_passcardStatus'] =  k['reason'] + ' Passcard';
                    }
                  } else if(k['status'] === 'Pending Termination' || k['status'].includes('Terminated')) {
                    if(k['reason'].includes('Pending')) {
                      k['_passcardStatus'] = 'Pending Passcard Issuence';
                    } else if(k['reason'].includes('Returned')) {
                      k['_passcardStatus'] = 'Passcard Returned';
                    } else {
                      k['_passcardStatus'] =  k['reason'] + ' Passcard';
                    }
                  }
                }
              }

              // if(k['_passcardStatus'] === 'ParkAide Active') {
              //   if(!k['_syncSeason'] || !k['_syncSeason'].active) {
              //     // if suppose to be parkaide active
              //     // but no sync status or sync status not active
              //     // allow manual sync to active
              //     k['_syncButton'] = 'Active ParkAide';
              //   } else {
              //     k['_syncButton'] = 'Block ParkAide';
              //   }
              // } else {
              // }
            });
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No lease data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      this.$refs['pageTable'].setTableData(null);

      // TODO skip type filter
      // if(!this.$refs['licenseFilter'].filterData || this.$refs['licenseFilter'].filterData.length === 0) {
      //   return;
      // }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      let temp = this.pageLease;
      for(let leaseData of temp) {
        if(leaseData['seasonID'] && this.pageSeasonFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };

      temp.forEach(k => {
        k['_license'] = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID'])) || {};
        k['_licenseStatus'] = (k['_license'] || {})['status'];
        k['_licenseNum'] = (k['_license'] || {})['licenseOperatorNum'];
        k['_carparkNum'] = (k['_license'] || {})['carparkID'];
        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
        k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']);
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']) || {};
        k['_parkerInformation'] = helper.plFormParker(k['_parker']) || {};
        k['_parkerName'] = k['_parker']['name'];
        k['_parkerMobile'] = k['_parker']['mobile'];

        let selectedSeasonFee = this.pageSeasonFees[k['seasonID']].find(j => j.isActive)
        if(!selectedSeasonFee) {
          for(let temp of this.pageSeasonFees[k['seasonID']]) {
            if(temp.startDate <= k.commencementDate) {
              selectedSeasonFee = temp;
              break;
            }
          }
        }
        selectedSeasonFee = selectedSeasonFee || {};
        switch(parseInt(k['paymentPlan'])) {
          case 1:
            k['_paymentPlan'] = 'Monthly';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['monthly']) + ' / month';
            break;
          case 2:
            k['_paymentPlan'] = 'Quarterly';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['quarterly'] * 3) + ' / quarter';
            break;
          case 3:
            k['_paymentPlan'] = 'Half-yearly';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['halfYearly'] * 6) + ' / half-year';
            break;
          case 4:
            k['_paymentPlan'] = 'Annually';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['annually'] * 12) + ' / annual';
            break;
        }

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;
      });

      // TODO skip type filter
      // temp = temp.filter(k => k['_customer'] && (this.$refs['typeFilter'].filterValue === 'Company' ? k['_customer'].isCompany : !k['_customer'].isCompany));
      
      // let filterCustomer = this.$refs['customerFilter'].filterValue;
      // if(filterCustomer) {
      //   temp = temp.filter(k => k['_customer'] && helper.compareID(k['_customer']['id'], filterCustomer));
      // }

      
      let final = [];
      for(let data of this.seasonSyncStatus) {
        let lease = temp.find(k => helper.compareID(k.id, data.leaseID));
        if(lease) {
          for(var key in lease) {
            data[key] = lease[key];
          }
          lease['_syncSeason'] = data;
        }
        data['_parkerName'] = data['name'];
        data['_parkerMobile'] = data['mobile'];
        data['_carparkName'] = data['carparkName'];
        data['id'] = data['activeID'];
        final.push(data);
      }
      
      this.$refs['pageTable'].setTableData(final, this.$refs['pageTable'].getCurrentPage());
    },
    loadSeason() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.pageSeasonFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
          //   // if(this.pageSeasonFees[seasonID] = response.data[0]) {
          //   if(this.pageSeasonFees[seasonID] = response.data) {
          //     this.$refs['pageFeedback'].setFeedbackMessage();
          //     this.loadLeaseData();
          //   } else {
          //     this.$refs['pageFeedback'].setFeedbackError('No active product fees data available.');
          //   }
          // } else {
          //   this.$refs['pageFeedback'].setFeedbackError('No product fees data available.');
          // }

          // TODO die die continue loading even though no valid fees
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageSeasonFees[seasonID] = response.data || [];
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          // TODO kw1 load too much data?
          helper.SERVER_URL + '/api2/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onTablePageChange() {
      this.loadSyncSeason();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadSyncSeason();
    },
    onCarparkFilterChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['typeFilter'].setFilterData(null);
      this.$refs['licenseFilter'].setFilterData(null);
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLicense();
    },
    onTypeFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      // this.setCustomerFilter();
      // this.loadLeaseData();
      this.setLicenseFilter();
      this.pageSeason = null;
      this.pageParker = null;
      this.loadSyncSeason();
    },
    onCustomerFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadSyncSeason();
    },
    onLicenseFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadSyncSeason();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['carparkFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Car Park Level', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Issue Passcard', tableData[tableDataIndex]);
    },

    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadLease();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Manual/PageManualParkaide2.vue